import { createSelector } from '@reduxjs/toolkit';

export const getProfile = ()=> {
    return createSelector(
        (state: any) => state.profile,
        (state) => state
    )
}